import { HttpClient } from '@angular/common/http';
import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import {
  AdminsApi, AlertsApi, AssetsApi, CmsApi, Configuration, ContactsApi, CredentialsApi, DisclaimersApi, 
  FeedbackApi, FilesApi, GroupsApi, IncidentsApi, IpawsApi, JobsApi, MapApi, QuestionnairesApi, RemoteCommandsApi, SettingsApi,
  TasklistsApi, TemplatesApi, TenantApi, UserApi
} from 'src/app/hickory-api';
import { MockAdminsApi } from './hickory-api/mock.adminsApi';
import { MockAlertsApi } from './hickory-api/mock.alertsApi';
import { MockAssetsApi } from './hickory-api/mock.assetsApi';
import { MockCmsApi } from './hickory-api/mock.cmsApi';
import { MockContactsApi } from './hickory-api/mock.contactsApi';
import { MockCredentialsApi } from './hickory-api/mock.credentialsApi';
import { MockDisclaimersApi } from './hickory-api/mock.disclaimersApi';
import { MockFeedbackApi } from './hickory-api/mock.feedbackApi';
import { MockFilesApi } from './hickory-api/mock.filesApi';
import { MockGroupsApi } from './hickory-api/mock.groupsApi';
import { MockIncidentsApi } from './hickory-api/mock.incidentsApi';
import { MockMapApi } from './hickory-api/mock.mapApi';
import { MockQuestionnairesApi } from './hickory-api/mock.questionnairesApi';
import { MockRemoteCommandsApi } from './hickory-api/mock.remoteCommandsApi';
import { MockSettingsApi } from './hickory-api/mock.settingsApi';
import { MockTasklistsApi } from './hickory-api/mock.tasklistsApi';
import { MockTemplatesApi } from './hickory-api/mock.templatesApi';
import { MockTenantApi } from './hickory-api/mock.tenantApi';
import { MockUserApi } from './hickory-api/mock.userApi';
import { MockJobsApi} from './hickory-api/mock.jobsApi';
import { MockIpawsApi } from './hickory-api/mock.ipawsApi';

@NgModule({
  providers: [
    { provide: AdminsApi, useClass: MockAdminsApi, deps: [HttpClient] },
    { provide: AlertsApi, useClass: MockAlertsApi, deps: [HttpClient] },
    { provide: AssetsApi, useClass: MockAssetsApi, deps: [HttpClient] },
    { provide: CmsApi, useClass: MockCmsApi, deps: [HttpClient] },
    { provide: ContactsApi, useClass: MockContactsApi, deps: [HttpClient] },
    { provide: CredentialsApi, useClass: MockCredentialsApi, deps: [HttpClient] },
    { provide: DisclaimersApi, useClass: MockDisclaimersApi, deps: [HttpClient] },
    { provide: FeedbackApi, useClass: MockFeedbackApi, deps: [HttpClient] },
    { provide: FilesApi, useClass: MockFilesApi, deps: [HttpClient] },
    { provide: GroupsApi, useClass: MockGroupsApi, deps: [HttpClient] },
    { provide: IncidentsApi, useClass: MockIncidentsApi, deps: [HttpClient] },
    { provide: JobsApi, useClass: MockJobsApi, deps: [HttpClient] },
    { provide: MapApi, useClass: MockMapApi, deps: [HttpClient] },
    { provide: QuestionnairesApi, useClass: MockQuestionnairesApi, deps: [HttpClient] },
    { provide: RemoteCommandsApi, useClass: MockRemoteCommandsApi, deps: [HttpClient] },
    { provide: SettingsApi, useClass: MockSettingsApi, deps: [HttpClient] },
    { provide: TasklistsApi, useClass: MockTasklistsApi, deps: [HttpClient] },
    { provide: TemplatesApi, useClass: MockTemplatesApi, deps: [HttpClient] },
    { provide: TenantApi, useClass: MockTenantApi, deps: [HttpClient] },
    { provide: UserApi, useClass: MockUserApi, deps: [HttpClient] },
    { provide: IpawsApi, useClass: MockIpawsApi, deps: [HttpClient] },
  ]
})
export class MockHickoryApiModule {
  public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<MockHickoryApiModule> {
    return {
      ngModule: MockHickoryApiModule,
      providers: [
        // Hickory APIs
        { provide: Configuration, useFactory: configurationFactory },
      ]
    };
  }

  constructor( @Optional() @SkipSelf() parentModule: MockHickoryApiModule, @Optional() http: HttpClient) {
    if (parentModule) {
      throw new Error('MockHickoryApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}